module.exports = new __parcel__URL__("about_1.04268265.jpg").toString();